import type { Proto } from "./Proto";

export interface DropDownItem<Id extends string | number = string | number> {
    items?: DropDownItem<Id>[];
    dropDownUUID?: string; //unique id for item
    isGroup?: boolean; //is item a dummy item used to just display a label for a group, eg, Your Searches
    groupName?: string;
    grp?: string; //alternative to group name from historical code
    toggleCollapse?: Function; //toggle isCollapsed
    isCollapsed?: boolean; //if item holds array of sub-items, is that list collapsed?
    isSelected?: boolean; //is item selected in dropdown
    lastStaticItem?: boolean; //is item the last static item in a dropdown list

    itemId?: Id; //identifies item semantically
    itemTypeId?: number; //identifies item type
    itemName?: string;
    itemDesc?: string; //sub-name, such as title, formal name, etc

    txt?: string; //itemName alternative from historical code
    val?: Id; //itemId alternative from historical code

    //stores original item name bc searching changes displayed item name to rich text to show matching substrings as bold
    //and we use this to switch it back to the original value
    dropDownOrigName?: string;

    favorite?: boolean | Proto.CharBoolean;
    noAnchorClick?: boolean; //disallow clicking item, if s25-item
    onItemSelect?: Function; //custom func to run on item select in dropdown using enter key

    [indexer: string]: any;
}

export namespace DropDownItem {
    export function hash(item?: DropDownItem): string | number | undefined {
        return item?.itemId ?? item?.val ?? item?.itemName;
    }
}
